<template>
  <div class="resources-filter__header js-filter-header">
    <div class="resources-filter__header-title">
      <h1>{{ this.heading }}</h1>
      <span class="resources-filter__mobile-icons-wrapper">
        <span @click="toggleFilters">
          <svg
            class="
              icon
              icon-filter
              resources-filter__message-icon
            "
          >
            <use xlink:href="#icon-filter"></use>
          </svg>
        </span>
        <span @click="toggleSearch">
          <svg
            class="
              icon
              icon-search
              resources-filter__message-icon
            "
          >
            <use xlink:href="#icon-search"></use>
          </svg>
        </span>
      </span>
    </div>
    <hr class="resources-filter__hr--main resources-filter__show" />
    <span class="resources-filter__filter-message">
      FILTER BY
    </span>
    <span class="resources-filter__information-wrapper">
      <span class="resources-filter__total-results">
        {{ this.totalResults }}
        {{ +this.totalResults === 1 ? 'Result' : 'Results' }}
        <span
          class="resources-filter__search-term-display"
          @click="clearSearchTerm"
          v-if="showSearchTerm"
        >
          for "{{ this.searchTerm }}" x
        </span>
      </span>
      <span class="resources-filter__selected-options">
        <span
          class="resources-filter__selected-option js-remove-selected-filter"
          v-for="selectedFilter in selectedFilters"
          :key="selectedFilter"
          :data-option-id="selectedFilter"
          @click="toggleOption(selectedFilter)"
        >
          {{ filters[selectedFilter] }} x
        </span>
      </span>
      <span
        class="resources-filter__clear-all"
        v-if="selectedFilters.length > 0"
        @click="clearFilters"
      >
        Clear All x
      </span>
    </span>
  </div>
</template>

<script>
import { TOGGLE_CATEGORIES, eventBus } from '../shared/event-bus';

export default {
  name: 'ResourcesFilterHeader',
  props: [
    'selectedFilters',
    'totalResults',
    'filters',
    'searchTerm',
    'heading',
  ],
  async mounted() {
    eventBus.$on(TOGGLE_CATEGORIES, data => {
      this.toggleFilters();
    });
  },
  computed: {
    showSearchTerm() {
      return (
        typeof this.searchTerm !== 'undefined' && this.searchTerm.length > 2
      );
    },
  },
  data() {
    return {
      searchOpen: false,
      filtersOpen: false,
    };
  },
  methods: {
    toggleOption(optionValue) {
      let selector = `.js-resources-filter-option[data-value="${optionValue}"] input[type=checkbox]`;
      document.querySelector(selector).click();
    },
    toggleSearch() {
      if (this.filtersOpen) {
        this.toggleFilters();
      }

      this.searchOpen = !this.searchOpen;

      const element = document.querySelector('.js-search-only');
      this.searchOpen
        ? (element.style.display = 'block')
        : (element.style.display = 'none');
    },
    toggleFilters() {
      if (this.searchOpen) {
        this.toggleSearch();
      }

      this.filtersOpen = !this.filtersOpen;

      const elements = document.querySelectorAll('.js-option-category');
      elements.forEach(element => {
        this.filtersOpen
          ? (element.style.display = 'block')
          : (element.style.display = 'none');
      });

      const mobileButtons = document.querySelector('.js-mobile-buttons');
      if (!!mobileButtons) {
        if (window.innerWidth >= 1024) {
          mobileButtons.style.display = 'none';
        } else {
          const optionsWrapper = document.querySelector(
            '.resources-filter__option-categories-wrapper'
          );
          this.filtersOpen
            ? (mobileButtons.style.display = 'flex')
            : (mobileButtons.style.display = 'none');
          this.filtersOpen
            ? (optionsWrapper.style.display = 'inherit')
            : (optionsWrapper.style.display = 'none');
        }
      }
    },
    clearFilters() {
      eventBus.clearAllFilters();
    },
    clearSearchTerm() {
      eventBus.refreshSearch();
    },
  },
};
</script>
